import React, { Component } from "react";
import { Link } from "react-router-dom";
import _ from "lodash";
import MobileDetect from "mobile-detect";
import { Pagination } from "antd";
import { stripHtml } from "../utils";
import { withRedux } from "../hoc";
import {
  LayoutPage,
  ArticleItem,
  BackgroundImage,
  Button,
  Parawow,
  Image,
} from "../components";
import { showEvents } from "../selectors/event";

const feather1 = `${process.env.PUBLIC_URL}/assets/images/event-page/event-1.png`;
const feather2 = `${process.env.PUBLIC_URL}/assets/images/event-page/event-2.png`;
const feather3 = `${process.env.PUBLIC_URL}/assets/images/event-page/event-3.png`;
const feather4 = `${process.env.PUBLIC_URL}/assets/images/event-page/event-4.png`;
const feather5 = `${process.env.PUBLIC_URL}/assets/images/event-page/event-5.png`;

const award1 = `${process.env.PUBLIC_URL}/assets/images/event-page/event-award2.png`;
const award2 = `${process.env.PUBLIC_URL}/assets/images/event-page/event-award1.png`;

const pageSize = 6;

const md = new MobileDetect(window.navigator.userAgent);

const mapStateToProps = ({ language, t, event, eventPage }) => {
  return {
    language,
    t,
    events: _.get(event, "data"),
    eventPage: _.get(eventPage, "data"),
  };
};

@withRedux(mapStateToProps)
export default class Events extends Component {
  state = {
    currentPage: 1,
  };
  onChangePage = (page) => {
    this.setState({
      currentPage: page,
    });
  };

  getEventContent = (content) => {
    const { t } = this.props;
    return (
      <React.Fragment>
        <div className="highlight-date">
          <p>{_.get(content, "date")}</p>
        </div>
        <div className="highlight-title">
          <h2>{t(_.get(content, "title"))}</h2>
        </div>
        <div className="highlight-content">
          <p
            className="benefits-detail"
            dangerouslySetInnerHTML={{
              __html: stripHtml(t(_.get(content, "description"))),
            }}
          />
        </div>
        <div className="container-highlight-button">
          {_.get(content, "website_url") && (
            <a href={_.get(content, "website_url")} target="_blank">
              <Button className="article-highlight-button website-button">
                Go to Website <i className="fa fa-arrow-right" />
              </Button>
            </a>
          )}

          <Link to={`/event/detail/${_.get(content, "id")}`}>
            <Button
              ghost
              bordercolor="#ffb400"
              className="article-highlight-button"
            >
              Read more <i className="fa fa-arrow-right" />
            </Button>
          </Link>
        </div>
      </React.Fragment>
    );
  };

  renderEvenTemplate = (event, index) => {
    return (
      <div className="article-highlight" key={index}>
        <Image className="award1" src={award1} alt="" />
        <div className="row no-gutters">
          <div className="col-lg-6">
            <div className="container-highlight-image">
              <BackgroundImage image={_.get(event, "image")} className="img" />
            </div>
          </div>
          <div className="col-lg-6 align-self-end">
            <div className="container-highlight-content">
              {this.getEventContent(event)}
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderOddTemplate = (event, index) => {
    return (
      <div className="article-highlight2" key={index}>
        <Image className="award2" src={award2} alt="" />
        <div className="row no-gutters">
          <div className="col-lg-6 align-self-end col-content">
            <div className="container-highlight-content2">
              {this.getEventContent(event)}
            </div>
          </div>
          <div className="col-lg-6">
            <div className="container-highlight-image">
              <BackgroundImage image={_.get(event, "image")} className="img" />
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { events, eventPage } = this.props;
    const { currentPage } = this.state;

    const orderEvents = showEvents(events);

    const otherEvents = _.slice(orderEvents, 3, _.size(orderEvents));

    const eventsHighlight = _.slice(orderEvents, 0, 3);

    const video = _.get(eventPage, "video");
    const imageBanner = _.get(eventPage, "imageBanner");
    const imageBannerMobile = _.get(eventPage, "imageBannerMobile");

    // getPagination
    const showItem = _.slice(
      otherEvents,
      (currentPage - 1) * pageSize,
      currentPage * pageSize
    );

    return (
      <div
        className={`events-page ${
          !_.isEmpty(md.mobile()) ? "hide-feather" : ""
        }`}
      >
        <LayoutPage
          type="primary"
          pageName="EVENTS"
          media={video}
          image={imageBanner}
          imageMobile={imageBannerMobile}
        />
        <div className="container">
          <div className="content">
            <Parawow
              scrollRange={[0, 800]}
              style={[{ top: "848px" }, { top: "1200px" }]}
            >
              {(style) => (
                <Image
                  className="feather1"
                  src={feather1}
                  alt=""
                  style={style}
                />
              )}
            </Parawow>
            <Parawow
              scrollRange={[0, 500]}
              style={[{ top: "213px" }, { top: "500px" }]}
            >
              {(style) => (
                <Image
                  className="feather2"
                  src={feather2}
                  alt=""
                  style={style}
                />
              )}
            </Parawow>
            {/* <Image className="feather1" src={feather1} alt="" /> */}
            {/* <Image className="feather2" src={feather2} alt="" /> */}
            <Image className="feather3" src={feather3} alt="" />
            <Image className="feather4" src={feather4} alt="" />
            <Image className="feather5" src={feather5} alt="" />

            <div className="highlight-block">
              {_.map(eventsHighlight, (event, index) => {
                const isEven = index % 2 === 0;
                return isEven
                  ? this.renderEvenTemplate(event, index)
                  : this.renderOddTemplate(event, index);
              })}
            </div>

            <div className="container-all-article">
              <div className="row">
                {_.map(showItem, (item, key) => {
                  return (
                    <div className="col-md-4" key={key}>
                      <div className="container-article-item">
                        <ArticleItem
                          darkFont
                          showDate
                          data={item}
                          pathOnClick={`/event/detail/${item.id}`}
                        />
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="container-pagination">
              <Pagination
                current={currentPage}
                defaultCurrent={currentPage}
                defaultPageSize={6}
                total={_.size(orderEvents)}
                onChange={this.onChangePage}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Events.js